import {
    Home,
    Users,
    Globe,
    FileText,
    Clipboard,
    Cloud,
    Smartphone
} from 'react-feather';

export const MENUITEMS = [
    {
        title: 'Dashboard', icon: Home, type: 'link', badgeType: 'primary', active: true, path: '/dashboard'
    },
    {
        title: 'Domain Management', icon: Globe, type: 'link', active: false, path: '/domain_management'
    },
    {
        title: 'Extension Management', icon: Smartphone, type: 'link', active: false, path: '/extension_management'
    },
    {
        title: 'Users', icon: Users, type: 'link', active: false, path: '/users'
    },
    {
        title: 'Netsapiens', icon: Cloud, type: 'link', active: false, path: '/netsapiens'
    },
    {
        title: 'Client Profiles', icon: Clipboard, type: 'link', active: false, path: '/client_profiles'
    },
]
